import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomepageButtons = () => {
  const navigate = useNavigate();

  return (
    <ul className="nhsuk-grid-row nhsuk-card-group mt-10 govuk-bp:mt-14">
      <li className="nhsuk-grid-column-one-half nhsuk-card-group__item">
        <div className="nhsuk-card nhsuk-card--clickable nhsuk-card--primary">
          <div className="nhsuk-card__content">
            <h2 className="nhsuk-card__heading nhsuk-heading-m">
              <a
                className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
                href="/new-patient"
              >
                Add New Resident / Create an Advance Care Plan
              </a>
            </h2>
            <p className="govuk-body">
              Document someone&apos;s Advance Care Plan and ensure that their
              wishes are adhered to.
            </p>
            <svg
              className="nhsuk-icon nhsuk-icon--chevron-right-circle"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              focusable="false"
              aria-hidden="true"
            >
              <path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm-.3 5.8a1 1 0 1 0-1.5 1.4l2.9 2.8-2.9 2.8a1 1 0 0 0 1.5 1.4l3.5-3.5c.4-.4.4-1 0-1.4Z" />
            </svg>
          </div>
        </div>
      </li>
      <li className="nhsuk-grid-column-one-half nhsuk-card-group__item">
        <div className="nhsuk-card nhsuk-card--clickable nhsuk-card--primary">
          <div className="nhsuk-card__content">
            <h2 className="nhsuk-card__heading nhsuk-heading-m">
              <a
                className="govuk-link govuk-!-font-weight-bold govuk-link--no-visited-state"
                href="/analytics"
              >
                View Analytics
              </a>
            </h2>
            <p className="govuk-body">
              View your organisations Analytics Dashboard. Data can be used for
              reflection and lead to improved levels of care.
            </p>
            <svg
              className="nhsuk-icon nhsuk-icon--chevron-right-circle"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              focusable="false"
              aria-hidden="true"
            >
              <path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm-.3 5.8a1 1 0 1 0-1.5 1.4l2.9 2.8-2.9 2.8a1 1 0 0 0 1.5 1.4l3.5-3.5c.4-.4.4-1 0-1.4Z" />
            </svg>
          </div>
        </div>
      </li>
    </ul>

    // <div className="care-place-info__buttons mt-10">
    //   <button
    //     className="govuk-button btn-left govuk-!-width-one-half nhsuk-card cursor-pointer"
    //     type="submit"
    //     data-testid="submitButton"
    //     onClick={() => navigate('/new-patient')}
    //   >
    //     <div className="btn-content">
    //       <h2 className="govuk-heading-m underline">Add New Resident/</h2>
    //       <h2 className="govuk-heading-m underline">
    //         Create an Advance Care Plan
    //       </h2>
    //       <p className="govuk-body">
    //         Document someone&apos;s wishes and preferences
    //       </p>
    //     </div>
    //   </button>
    //   <button
    //     className="govuk-button govuk-button--secondary govuk-!-width-one-half nhsuk-card"
    //     type="submit"
    //     data-testid="submitButton"
    //     onClick={() => navigate('/analytics')}
    //   >
    //     <div className="btn-content">
    //       <h2 className="govuk-heading-m underline">View Analytics</h2>
    //       <p className="govuk-body">
    //         Review and assess your organisations Advance Care Planning progress
    //       </p>
    //     </div>
    //   </button>
    // </div>
  );
};

export default HomepageButtons;
